export default {
  title: 'Haluatko varmasti kirjautua ulos?',
  buttons: {
    logout: 'Kirjaudu ulos',
    cancel: 'Peruuta',
  },
};
